"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReaction = exports.useReactiveState = void 0;
const react_1 = require("react");
const features_1 = require("../features");
const isObject = (item) => !!(item && typeof item === 'object' && item.constructor === Object);
const setValue = (object, state) => {
    Object.entries(object).forEach(([key, value]) => {
        if (isObject(value)) {
            if (!state[key]) {
                state[key] = {};
            }
            setValue(value, state[key]);
        }
        else {
            state[key] = value;
        }
    });
};
const increment = (x) => x + 1;
const useReactiveState = (observer) => {
    const [, render] = (0, react_1.useReducer)(increment, 0);
    const [reactiveState, setReactiveState] = (0, react_1.useState)(() => (0, features_1.getAutoObservable)(observer, render));
    const stateRef = (0, react_1.useRef)(reactiveState);
    const firstRender = (0, react_1.useRef)(true);
    reactiveState.subscribe();
    const setState = (0, react_1.useCallback)((object) => {
        (0, features_1.runReaction)(() => setValue(object, stateRef.current.observable));
    }, []);
    (0, react_1.useEffect)(() => {
        reactiveState.unsubscribe();
    });
    (0, react_1.useEffect)(() => {
        if (firstRender.current) {
            firstRender.current = false;
        }
        else {
            stateRef.current = (0, features_1.getAutoObservable)(observer, render);
            setReactiveState(stateRef.current);
        }
        return () => stateRef.current.dispose();
    }, [observer]);
    return [reactiveState.observable, setState];
};
exports.useReactiveState = useReactiveState;
const useReaction = (callback, deps = []) => {
    const ref = (0, react_1.useRef)(callback);
    ref.current = callback;
    (0, react_1.useEffect)(() => (0, features_1.autorun)(() => ref.current()), deps);
};
exports.useReaction = useReaction;
//# sourceMappingURL=adapter.js.map